module.exports = __webpack_public_path__ + "static/media/Home PAG.f20b36f3.svg";